import AddOutlinedIcon from "@mui/icons-material/AddOutlined"
import Button from "@mui/material/Button"
import Chip from "@mui/material/Chip"
import Link from "@mui/material/Link"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { Link as RouterLink } from "react-router-dom"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import TitledSection from "../../../common/components/TitledSection"
import CustomPerkDialog from "../components/offers/CustomPerkDialog"
import { useCustomPerksState } from "../utils"
import ConfirmDeletePerkDialog from "./ConfirmDeletePerkDialog"

export default function PerksSection() {
  const {
    customPerks,
    setCustomPerks,
    openCustomPerkDialog,
    handleCustomPerkDialogClosed,
    customPerkDialogOpen,
    editedPerk,
    setEditedPerk,
  } = useCustomPerksState()
  const [confirmDeletePerkDialogOpen, setConfirmDeletePerkDialogOpen] =
    useState(false)

  function handlePerkChipClicked(perk) {
    setEditedPerk(perk)
    openCustomPerkDialog()
  }

  function handleDeletePerkButtonClicked(perk) {
    setEditedPerk(perk)
    setConfirmDeletePerkDialogOpen(true)
  }

  function handleConfirmDeletePerkDialogClosed(deleted) {
    if (deleted) {
      setCustomPerks(customPerks.filter((perk) => perk.id !== editedPerk.id))
    }
    setEditedPerk(null)
    setConfirmDeletePerkDialogOpen(false)
  }

  return (
    <TitledSection variant="h5" title="Perks">
      <Column sx={{ alignItems: "flex-start", gap: 2 }}>
        <Typography variant="body1">
          You can create custom perks which you can use inside new{" "}
          <Link to="/proposals" component={RouterLink}>
            proposals
          </Link>
          .
        </Typography>
        {customPerks.length === 0 ? (
          <>
            <Typography variant="h5">No custom perks added yet.</Typography>
            <AddPerkButton onClick={openCustomPerkDialog} />
          </>
        ) : (
          <Row sx={{ alignItems: "center", flexWrap: "wrap", gap: 2 }}>
            {customPerks.map((perk) => (
              <Chip
                key={perk.id}
                color="secondary"
                label={perk.title}
                onClick={() => handlePerkChipClicked(perk)}
                onDelete={() => handleDeletePerkButtonClicked(perk)}
              />
            ))}
            <AddPerkButton onClick={openCustomPerkDialog} />
          </Row>
        )}
        <CustomPerkDialog
          open={customPerkDialogOpen}
          onClose={handleCustomPerkDialogClosed}
          perk={editedPerk}
        />
        <ConfirmDeletePerkDialog
          open={confirmDeletePerkDialogOpen}
          onClose={handleConfirmDeletePerkDialogClosed}
          perk={editedPerk}
        />
      </Column>
    </TitledSection>
  )
}

function AddPerkButton({ onClick }) {
  return (
    <Button
      variant="outlined"
      size="small"
      sx={{ height: "32px" }}
      onClick={onClick}
      endIcon={<AddOutlinedIcon />}
    >
      Add perk
    </Button>
  )
}
